import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'

class RegulationAvonComponent extends Component {
  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Regulamentos - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid bg-color-ui-4'>
          <div className='container mt-5 pb-5'>
            <div className='row py-5 pb-5'>
              <div className='col-12 px-1 py-3 px-md-2'>
                <div className='row  mx mx-md-0'>
                  <div className='col-12 bg-white border-ui-3 radius-0 radius-md'>
                    <div className='row border-bottom border-color-ui-3'>
                      <div className='col-12 px-3 py-3'>
                        <h3>REGULAMENTO MEU MUNDO AVON</h3>
                      </div>
                    </div>
                    <div className='col-12 px-2 px-md-3 py-3' role='article'>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>1. DISPOSIÇÕES GERAIS</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        1.1 As presentes disposições regulam o programa de
                        incentivo na modalidade de pontos, denominado “Meu Mundo
                        Avon” (“Programa”), por meio do qual são atribuídos
                        pontos (“Pontos”) às Revendedoras Avon e Revendedoras
                        participantes do Programa Executiva de Vendas Avon
                        (“Revendedoras”), a partir de sua adesão ao Programa,
                        podendo referidos Pontos serem convertidos nos prêmios e
                        serviços disponíveis no catálogo Meu Mundo Avon.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        1.2 O Programa é administrado pela AVON COSMÉTICOS
                        LTDA., pessoa jurídica de direito privado, com sede na
                        Avenida Interlagos, n° 4300, Prédio Administrativo, 1º e
                        2º andares, no município de São Paulo, SP, inscrita no
                        CNPJ/MF sob nº 56.991.441/0001-57 (“Avon”), em parceria
                        com fornecedores de bens de consumo (“Parceiros”).
                      </p>

                      <p className='txt-body-sm mb-2'>
                        1.3 A adesão ao Programa é automática e compreende todas
                        as Revendedoras cadastradas na Avon.
                      </p>

                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>2. PONTOS NO PROGRAMA MEU MUNDO AVON</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        2.1. Os Pontos são as unidades de medida utilizadas pela
                        Avon neste Programa. O acúmulo de Pontos se dará
                        exclusivamente mediante o atendimento, pelas
                        Revendedoras, das condições e objetivos definidos em
                        cada um dos Programas de Incentivos Participantes
                        (“Programas Participantes”), conforme definido pela
                        Avon.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        2.2.Ao acumular Pontos, as Revendedoras poderão realizar
                        o resgate de prêmios e serviços no catálogo Meu Mundo
                        Avon (“Resgate”), observados os valores necessários para
                        cada produto, de acordo com o previsto no catálogo Meu
                        Mundo Avon em vigor.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        2.3. Os Pontos válidos para este Programa estarão
                        disponíveis para Resgate tão logo sejam validados
                        conforme as regras dos Programas Participantes. Os
                        prazos e condições para a validação, contabilização,
                        acúmulo e validade dos Pontos estarão previstos em cada
                        um dos Programas Participantes.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        2.4. A Revendedora terá um prazo de até 6 (seis)
                        campanhas, contadas a partir da campanha de validação do
                        Ponto para realizar qualquer questionamento sobre
                        eventuais discrepâncias na pontuação contabilizada.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        2.5. Os Pontos não são negociáveis ou transferíveis
                        (compra, venda, cessões, doações ou permuta de Pontos).
                        A comprovação de que a Revendedora tenha incorrido em
                        tais práticas, assim como outras práticas correlatas
                        e/ou que gerem o mesmo efeito, acarretará o cancelamento
                        automático dos Pontos.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        2.6. Os Pontos terão a validade ques lhes for atribuída
                        pelos Programas Participantes e, uma vez decorrido este
                        prazo, expirarão automaticamente.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        2.7. Em nenhuma hipótese, os Pontos serão convertidos
                        total ou parcialmente em dinheiro, seja em crédito em
                        conta e/ou em pecúnia.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>3. COMPANHAMENTO DOS PONTOS</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        3.1. Ao utilizar a Plataforma, o Usuário declara e
                        reconhece que: A Revendedora poderá obter informações
                        sobre os objetivos e condições específicas para acúmulo
                        de Pontos:
                        <br />
                        i. Na Revista Avon Comigo da Campanha em que o Programa
                        Participante for divulgado;
                        <br />
                        ii. No site www.avon.com.br, clicando em Acesse sua Área
                        Exclusiva &#62; Clique no menu “Meus Incentivos” e
                        consulte os regulamentos dos Programas Participantes;
                        <br />
                        iii. No Serviço de Atendimento à Revendedora (SAR) -
                        0800 708 2866;
                        <br />
                      </p>
                      <p className='txt-body-sm mb-2'>
                        3.1.1 Os Pontos poderão ser consultados através do site
                        www.avon.com.br, na Plataforma de Resgates, item “Meus
                        Pontos”.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>3.2. COMPANHAMENTO DOS PONTOS</strong>
                      </p>

                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>3.2.1 Estágio 1: Pontos Pendentes</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        3.2.1 Ao atingir as condições e objetivos definidos nos
                        Programas Participantes, a Revendedora acumulará Pontos
                        que serão considerados como pendentes até que sejam
                        validados de acordo com as regras do Programa
                        Participante.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>
                          Estágio 2: Validação e Disponibilização dos Pontos
                        </strong>
                      </p>

                      <p className='txt-body-sm mb-2'>
                        3.2.2.1 Os Pontos estarão disponíveis após cumpridas as
                        regras de validação mencionadas nos Programas
                        Participantes, disponível no site Avon Comigo –{' '}
                        <a href='www.avon.com.br'>www.avon.com.br</a>.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        3.2.2.2 Eventuais questionamentos sobre a validação e
                        disponibilização dos Pontos deverá ser feita nos termos
                        descritos neste regulamento, observando-se o prazo
                        estabelecido na cláusula 2.4, assim como a aplição das
                        regras previstas em cada um dos Programas Participantes.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>3.2.3. Estágio 3: Pontos Cancelados</strong>
                      </p>

                      <p className='txt-body-sm mb-2'>
                        3.2.3.1 Os Pontos não validados de acordo com as regras
                        acima descritas, serão cancelados de acordo com o
                        regulamento do Programa.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        3.2.4. Pontos adquiridos por fraudes ou condutas
                        inadequadas ou não condizentes com a política e cultura
                        da Avon, acarretam no cancelamento dos pontos.Estagio 4:
                        Pontos Expirados
                      </p>

                      <p className='txt-body-sm mb-2'>
                        3.2.4.1. Conforme estabelecido na cláusula 2.6, os
                        Pontos acumulados expirarão automaticamente assim que a
                        data final de validade descrita no respectivo Programa
                        de Incentivo for atingida.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>4. RESGATE DE PONTOS</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.1. As Revendedoras poderão efetuar Resgates utilizando
                        o saldo do Pontos existente em sua conta desde o momento
                        que o Ponto for validado, até a data de sua expiração.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.2. No ato do Resgate, os Pontos acumulados serão
                        abatidos automaticamente dos Pontos disponíveis e
                        desbloqueados para uso, na ordem decrescente de
                        validade.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.3. O Resgate de Pontos poderá não consumir a
                        totalidade dos Pontos disponíveis no extrato da
                        Revendedora. Neste caso, o saldo de Pontos remanescentes
                        poderá ser utilizado pela Revendedora para um novo
                        Resgate, observando-se a data de expiração dos Pontos.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.4. As opções dos prêmios disponíveis para Resgate
                        estarão no site (www.avon.com.br clicando em Acesse sua
                        Área Exclusiva &#62; Clique no menu “Incentivos” &#62;
                        Clique em “Resgate Meu Mundo Avon”). Sem prejuízo a Avon
                        enviará uma prévia contida em catálogos impressos do Meu
                        Mundo Avon, que serão enviados na caixa de pedidos da
                        Revendedora. Para referência sobre os catálogos,
                        consulte a cláusula 6
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.5. A Revendedora poderá resgatar seus Pontos:
                        <br />
                        i. Através do site www.avon.com.br clicando em Acesse
                        sua Área Exclusiva &#62; Clique no menu “Meus
                        Incentivos” &#62; Clique em “Resgate Meu Mundo Avon”;
                        <br />
                        ii. no Serviço de Atendimento à Revendedora (SAR) 0800
                        708 2866.
                        <br />
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6. Se o resgate de pontos se der por veículos
                        automotores (carros e/ou motos), vouchers ou Viagens,
                        deverão ser respeitadas as seguintes regras abaixo:
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>
                          4.6.1 Veículos automotores (carros e/ou motos)
                        </strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.1.1. O prazo para entrega do veículo é de 120 (cento
                        e vinte) dias a contarda data do resgate na plataforma
                        de prêmios. Esse prazo pode ser maior dependendo da
                        disponibilidade da concessionária, dos trâmites legais
                        aplicáveis e da disponibilização dos documentos
                        necessários pela Revendedora participante. Se o prazo
                        para entrega for superior ao estabelecido inicialmente
                        nesta cláusula, será feita a comunicação via e-mail dos
                        ganhadores.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.1.2. A entrega do veículo deverá ocorrer
                        obrigatoriamente no endereço da Revendedora
                        participante, ficando vedada a emissão dos documentos do
                        veículo em um endereço e a entrega do prêmio em outro.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.1.3. A Revendedora participante que resgatar um
                        veículo, terá 30 (trinta) dias, a partir da data de
                        divulgação dos ganhadores, para enviar os documentos
                        abaixo para a Avon:
                        <br />
                        - Cópia do RG;
                        <br />
                        - Cópia do CPF;
                        <br />
                        - Cópia do Comprovante de Residência.
                        <br />
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.1.4 A Revendedora participante deverá realizar a
                        transferência da documentação do veículo em até 30
                        (trinta) dias após a data de recebimento da
                        documentação. A transferência poderá ser feita somente
                        em nome da Revendedora participante que realizou o
                        resgate do veículo Na hipótese de atraso ou não
                        cumprimento da legislação aplicável, a Revendedora
                        participante arcará exclusivamente com todas as
                        penalidades, pontuações, custos e despesas decorrentes
                        destes atos.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.1.5. Os custos da transferência serão arcados pela
                        Avon em até 30 (trinta) dias a contar da data de emissão
                        da Nota Fiscal. Após este prazo, a Revendedora
                        participante passa a ser responsável por pontuações na
                        Carteira Nacional de Habilitação e todos os custos
                        adicionais.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.1.6. Os processos de vistoria e emplacamento do
                        veículo são de total responsabilidade da Revendedora
                        participante, sendo que a não efetuação desse
                        procedimento implica em não conclusão da transferência e
                        a perda do direito ao prêmio.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.1.7. Caso o veículo tenha saído de linha ou não haja
                        disponibilidade no mercado, a Avon oferecerá à
                        Revendedora participante o modelo pelo qual o veículo
                        tenha sido substituído no mercado ou similar.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>4.6.2 Vouchers</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.2.1. Após o recebimento do voucher a Revendedora
                        deverá seguir as orientações contidas no Regulamento de
                        Incentivo específico ou, não havendo, seguir as
                        orientações do fornecedor do Voucher para cadastro,
                        desbloqueio e utilização do prêmio.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.2.2. Uma vez desbloqueado, o voucher poderá ser
                        utilizado, dentro do prazo de validade, no limite de seu
                        crédito, como meio de pagamentos na aquisição de bens
                        e/ou serviços nos estabelecimentos credenciados à
                        bandeira indicada no respectivo cartão.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.2.3. Nas operações realizadas via internet, telefone
                        ou outros canais eletrônicos, a confirmação poderá ser
                        solicitada conforme procedimentos específicos para tais
                        canais, sendo que a utilização de senha e/ou aposição de
                        assinatura poderá ser substituída pela indicação do
                        número do cartão e a data de validade, desde que o
                        estabelecimento credenciado esteja autorizado a efetuar
                        transações por este meio.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.2.4. A inclusão da senha ou a confirmação da
                        operação caracterizam a sua concordância com a operação.
                        A Emissora não se responsabiliza por eventual restrição
                        imposta pelos Estabelecimentos Credenciados ao uso do
                        voucher, nem pelo preço, qualidade ou quantidade
                        declarados dos bens adquiridos ou serviços prestados.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.18. A utilização do voucher será interrompida nas
                        seguintes situações: a. Solicitação de cancelamento ou
                        bloqueio; b. Comunicação de perda, roubo, furto ou
                        extravio à emissora do cartão; c. Cancelamento/bloqueio
                        do voucher por exigência judicial, do Banco Central do
                        Brasil ou qualquer outro órgão governamental competente,
                        por utilização ilícita ou em desacordo com as normas
                        vigentes; d. Suspeita de fraude. e. Caso o bloqueio do
                        cartão ocorra por algum problema técnico que não tenha
                        sido causado pelo ganhador, será emitido um novo cartão
                        para a Revendedora Participante
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.2.6. A utilização do voucher estará sujeita à
                        disponibilidade da rede de cartões da Bandeira destacada
                        no cartão da emissora.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.2.6. O voucher não poderá ser utilizado para saques
                        em dinheiro.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>4.6.3. Viagens</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.1. Na hipotese de viagem internacional, a obtenção
                        de passaporte devidamente válido, juntamente com o
                        respectivo visto que viabilize a entrada em território
                        estrangeiro será de inteira responsabilidade da
                        Revendedora e eventual acompanhante, devendo ela arcar
                        com todo e qualquer custo relacionado à obtenção de tais
                        documentos.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.2. Também ficarão sob a responsabilidade da
                        Revendedora e seu acompanhante as providências relativas
                        a documentos e outras providências de caráter pessoal.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.3. No caso de perda do voo (ida ou volta), por
                        culpa exclusiva da Revendedora e/ou seu acompanhante,
                        estes não terão direito a receber outro bilhete aéreo,
                        sendo que o custo de eventual substituição do bilhete e
                        demais despesas, deverão ser arcadas inteiramente pela
                        Revendedora.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.4. Caso a entrada no país de destino seja, por
                        qualquer motivo, negada ao ganhador e/ou seu
                        acompanhante, pelas autoridades locais aeroportuárias
                        internacionais, a Avon ficará isenta de qualquer
                        responsabilidade.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.5. A Avon não tem qualquer responsabilidade sobre
                        os objetos pessoais levados pelos ganhadores e seus
                        acompanhantes na viagem.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.6. A Avon não se responsabilizará por qualquer ato
                        pessoal que os ganhadores e/ou seus acompanhantes venham
                        a cometer em afronta aos bons costumes, a moral, a ordem
                        e as leis durante a viagem e venham a causar danos
                        materiais ou físicos a outrem durante a viagem.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.7. Ao adquirir um vale-viagem, a Revendedora está
                        ciente que este tem validade de 1 ano e que deverá ser
                        trocado por sua viagem ou experiência dentro da
                        plataforma MMA Viagens no próprio Catálodo do Meu Mundo
                        Avon.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.8. Ao utilizar o vale-viagem na plataforma MMA
                        Viagens, a Revendedora está ciente que:
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.1. A solicitação de troca de pontos por serviços
                        turísticos, em nenhuma hipótese, poderá ser cancelada.
                        NÃO SERÁ ADMITIDA QUALQUER ALTERAÇÃO OU CANCELAMENTO DO
                        PEDIDO DE RESGATE APÓS A EFETIVAÇÃO DA TROCA DOS PONTOS
                        POR SERVIÇOS TURÍSTICOS E OS PONTOS RESGATADOS NÃO SERÃO
                        RESTITUÍDOS.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.2. Caso o premiado não utilize os serviços,
                        inclusive o bilhete emitido na data e horários
                        escolhidos, este perderá sua validade e a pontuação NÃO
                        será estornada.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.3. O cancelamento do resgate somente poderá
                        ocorrer nos casos de falecimento ou doenças de natureza
                        infectocontagiosas do premiado. Neste caso, tais
                        situações deverão ser comprovadas por meio de um laudo
                        médico e/ou mediante apresentação de outros documentos
                        pertinentes a serem solicitados pela WEB PRÊMIOS
                        TURISMO, cabendo a esta avaliar, a seu exclusivo
                        critério, o cancelamento ou não do resgate realizado.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.4. O participante somente poderá efetuar a
                        aquisição dos serviços turísticos e passagens aéreas que
                        estiverem disponíveis no momento do resgate.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.5. Após o resgate, o envio das informações
                        relativas ao serviço e a emissão do bilhete/confirmação
                        de resgate se dará por meio do e-mail informado pelo
                        participante no momento do resgate, sendo de sua
                        exclusiva responsabilidade a veracidade das informações
                        fornecidas. A WEB PRÊMIOS TURISMO não se responsabiliza
                        pelo não recebimento do e-mail pelo participante. Caso o
                        participante não venha a receber o e-mail com a
                        informação de seu resgate no prazo de até 6 (seis) horas
                        contadas do resgate, deverá entrar em contato com a
                        Central de Atendimento da sua Campanha.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.6. As taxas de embarque poderão ser pagas com a
                        utilização dos pontos.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.7. Eventual complemento com cartão de crédito,
                        bem como as taxas de embarque não são reembolsáveis após
                        a conclusão do resgate.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.8. Após a conclusão do resgate não será
                        permitida alteração dos serviços contratados e do
                        bilhete, inclusive no que tange a data de embarque,
                        horário, companhia aérea, passageiro, ou qualquer outro
                        item.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.9. É de exclusiva responsabilidade dos hotéis,
                        das companhias aéreas e terceiros, a qualidade e a
                        garantia dos produtos e/ou serviços oferecidos. A WEB
                        PRÊMIOS TURISMO não poderá ser responsabilizada pela
                        indisponibilidade dos serviços das companhias aéreas ou
                        hotéis ou qualquer cancelamento ou alteração de data e
                        horário, ficando sob responsabilidade da Companhia
                        Aérea/terceiro a restituição ao participante.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.10. A Avon não se responsabiliza por acidentes,
                        atrasos ou outros imprevistos ocorridos durante a
                        realização de viagens, estadas ou outros eventos
                        escolhidos pelo premiado, ficando sob sua conta,
                        responsabilidade e despesas a realização dos seguros
                        correspondentes, se assim desejar.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.11. Na hipótese de cisão, cessão, fusão,
                        incorporação, recuperação judicial ou falência decretada
                        pelas empresas fornecedoras, as mesmas serão as únicas e
                        exclusivas responsáveis pelas perdas e danos
                        eventualmente causados aos clientes, decorrentes de sua
                        troca de pontos por passagens aéreas.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.12. Ao realizar o resgate o participante desde
                        logo autoriza que suas informações cadastrais sejam
                        divulgadas aos responsáveis pela emissão do bilhete e
                        demais documentos necessários à contratação dos
                        serviços. Caso a emissão do bilhete ou contratação dos
                        serviços não seja possível devido a informações
                        incorretas prestadas pelo premiado, o premiado terá o
                        prazo de 3 (três) dias para entrar em contato com a
                        Central de Atendimento e solucionar o problema. Após
                        esse prazo, o participante perderá o direito ao prêmio
                        resgatado.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.6.3.8.13. As demais condições específicas para
                        resgates de passagens aéreas e serviços turísticos
                        estarão descritas no momento do aceite do resgate e
                        deverão ser consideradas como complemento deste
                        Regulamento.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.7. A Revendedora será responsável por todas as
                        informações fornecidas à Avon, no momento do resgate,
                        assim como por observar as disposições deste
                        regulamento, a ela aplicável, sob pena da Revendedora
                        perder o direito à recompensa ou aos Pontos, e até mesmo
                        ser excluída do Programa, caso esta não observe o
                        disposto neste regulamento ou alegue desconhecer seu
                        teor.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.8. A escolha do prêmio é de responsabilidade exclusiva
                        da Revendedora, sendo que, após a escolha, não será
                        aceita a troca por outro prêmio ou qualquer alteração de
                        sua característica, qualidade e origem, nem haverá a
                        possibilidade de conversão em dinheiro, em hipótese
                        alguma.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.9. A Revendedora deverá manter sempre o seu número de
                        telefone, e-mail e endereço atualizados no momento do
                        Resgate, respondendo integralmente por qualquer extravio
                        e/ou impossibilidade de entrega decorrente da não
                        atualização de seus dados. Havendo impossibilidade de
                        entrega, a Revendedora deverá observar as regras
                        previstas na cláusula 5.2 deste regulamento.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        4.10. É de responsabilidade da Revendedora a escolha da
                        voltagem de eventuais produtos elétricos escolhidos no
                        momento do Resgate, isentando a Avon da responsabilidade
                        por substituir o produto no caso do Resgate incorreto.
                      </p>

                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>5. ENTREGA DE PRÊMIOS</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.1. A entrega dos prêmios resgatados pelas Revendedoras
                        poderá ocorrer em duas formas distintas, a depender da
                        característica do prêmio por esta escolhido e da
                        disponibilidade de meios de entrega no momento do
                        Resgate:
                      </p>

                      <p className='txt-body-sm mb-2'>
                        5.1.1. Caixa de Mercadorias Avon: Para a entrega do
                        prêmio na caixa de Mercadorias Avon, a Avon terá o prazo
                        máximo de até 4 campanhas, observando o prazo máximo de
                        60 (sessenta) dias, contados da data de concretização do
                        Resgate, desde que a Revendedora coloque um pedido em
                        uma das Campanhas de Vendas Avon relacionadas ao
                        referido período.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        5.1.2. Se por alguma razão de disponibilidade de estoque
                        o produto não estiver disponível para resgate, a Avon se
                        reserva o direito de estornar os pontos para que o
                        Revendedor resgate outro item disponível do catálogo.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        5.1.3. Caso identifique que enviou seu pedido Avon e não
                        recebeu o prêmio na sua caixa de mercadorias, a
                        Revendedora terá 30 (trinta) dias a partir do prazo
                        final de 60 (sessenta) dias após a realização do Resgate
                        para entrar em contato com o Serviço de Atendimento à
                        Revendedora, a fim de solicitar nova entrega. Após este
                        prazo de 30 dias, a Revendedora perderá o direito ao
                        prêmio e os Pontos não serão devolvidos. Tenha sempre em
                        mãos o protocolo de solicitação.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        5.1.4. Entrega por Lojas Parceiras: Para entrega de
                        prêmios de lojas parceiras, o prazo será informado no
                        momento do Resgate. A Avon realizará o monitoramento da
                        entrega dos prêmios resgatados no Programa Meu Mundo
                        Avon, auxiliando a Revendedora até o efetivo recebimento
                        do prêmio escolhido. Todavia, é de exclusiva
                        responsabilidade dos Parceiros e da Loja Parceira:{' '}
                        <br />
                        i. a gestão de estoque e disponibilidade dos prêmios;{' '}
                        <br />
                        ii. a entrega do prêmio indicada no tempo e local
                        designado; <br />
                        iii. as condições físicas do prêmio entregue. <br />
                        <br />
                        O parceiro será responsável pelo envio do prêmio, dada
                        as seguintes condições:
                        <br />
                        i. O endereço de entrega do produto está restrito ao
                        território nacional, atendido pelos correios ou pelos
                        serviços de entrega dos Parceiros de Resgate e/ou Loja
                        Parceira;
                        <br />
                        ii. O endereço de entrega do produto poderá estar
                        restrito exclusivamente ao endereço de cadastro do
                        Participante, cabendo exclusivamente à Livelo autorizar
                        envio de produtos a outros endereços em nome do
                        Participante;
                        <br />
                        iii. Determinadas localidades podem não ser atendidas
                        pelo(s) Parceiro(s) de Resgate desejado(s) pelo
                        Participante, sendo a impossibilidade informada no
                        carrinho, no momento do Resgate.
                        <br />
                      </p>

                      <p className='txt-body-sm mb-2'>
                        5.2. Caso não seja possível entregar o prêmio em razão
                        do fornecimento incorreto de informações pela
                        Revendedora, mudança de endereço não informada ou
                        ausência no momento da entrega, os pontos serão
                        estornados para que a Revendedora resgate outro item.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        5.3. A Revendedora terá 30 (trinta) dias a partir do
                        prazo de entrega estipulado pelo parceiro após a
                        realização do Resgate para entrar em contato com o
                        Serviço de Atendimento à Revendedora, a fim de solicitar
                        nova entrega e/ou retificar seus dados. Após este prazo
                        de 30 dias, a Revendedora perderá o direito ao prêmio e
                        os Pontos não serão devolvidos. Tenha sempre em mãos o
                        protocolo de solicitação.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.4. Uma vez constatado que o prêmio entregue contém
                        qualquer defeito, avaria, ou que não se trata do produto
                        solicitado, a Revendedora deverá formular reclamação à
                        Avon no Call Center (0800 708 2866), nos prazos abaixo
                        estabelecidos, para análise e eventual substituição por
                        outro produto similar em perfeitas condições.
                        Ressalta-se que esses prazos serão contados da data de
                        recebimento dos produtos. Após este prazo, a Revendedora
                        deverá efetuar sua reclamação diretamente ao fabricante.
                        i. Defeito – 07 (sete) dias corridos; ii. Recebimento de
                        item avariado – Caso o produto recebido seja avariado
                        durante o transporte, recuse o recebimento imediatamente
                        e entre em contato com o Serviço de Atendimento à
                        Revendedora; iii. Recebimento de item divergente – 03
                        (três) dias corridos; iv. Recebimento de item sem
                        acessório – 07 (sete) dias corridos; v. Troca por
                        voltagem – 07 (sete) dias corridos (apenas no caso de
                        envio incorreto pelo Parceiro).
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.5. A responsabilidade pela qualidade, garantia,
                        especificações técnicas e durabilidade dos prêmios
                        fornecidos é exclusiva dos Parceiros que os fabricam
                        e/ou os fornecerem, sendo a Revendedora responsável,
                        entretanto, por observar as especificações contidas nos
                        manuais de utilização dos prêmios, além de guardar os
                        respectivos certificados de garantia e nota fiscal dos
                        prêmios para troca em caso de defeitos, ou para eventual
                        assistência técnica, no prazo fixado pelos fabricantes,
                        caso não possa mais ser reclamado perante à Avon, nos
                        termos da cláusula 5.3 acima.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.6. Os produtos devem ser devolvidos preferencialmente
                        na embalagem original. É indispensável que o lacre
                        original do fabricante esteja intacto e que as
                        mercadorias tenham nota fiscal, manual e todos os
                        acessórios. Poderão ser aplicáveis outros requisitos a
                        depender das características dos prêmios e do Parceiro
                        responsável pelo fornecimento.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.7. Ainda dentro da embalagem, a Revendedora deve
                        colocar a última via da nota fiscal recebida no ato da
                        entrega e descrever, no verso da nota o motivo da sua
                        devolução.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.8. A Revendedora deve solicitar o comprovante no
                        momento da retirada da mercadoria para análise. Caso o
                        transportador não possua tal protocolo, a revendedora
                        não deve entregar a mercadoria e deve comunicar à Avon o
                        ocorrido por meio do Serviço de Atendimento à
                        Revendedora (SAR) no telefone 0800 708 2866.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.9. Caso a reclamação ultrapasse o prazo máximo, os
                        prêmios não serão trocados e nem analisados. Nesse caso,
                        a Revendedora poderá dirigir-se a uma das assistências
                        técnicas credenciadas pelo próprio fabricante, indicadas
                        no manual. A garantia contratual é de inteira
                        responsabilidade do fabricante e seu prazo e forma de
                        utilização constam do termo de garantia que acompanha o
                        produto.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.10. Danos causados por uso indevido dos prêmios são de
                        inteira responsabilidade da Revendedora, não sendo
                        realizadas substituições ou reparações gratuitas por
                        este motivo.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.11. Para a premiação resgatada ser entregue, a
                        Revendedora tem que se encontrar ativa no ato do
                        recebimento, atendendo à todas as condições do
                        regulamento do Programa, bem como do regulamenmto dos
                        Programas Participantes.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        5.12. Estorno de pontos: todo ponto estornado terá
                        validade de 30 dias a contar da data do estorno e é de
                        responsabilidade da Revendedora resgatar novamente antes
                        da expiração. Pontos expirados não serão devolvidos por
                        nenhum motivo. A Revendedora deve acompanhar seus pontos
                        estornados no catálogo de prêmios.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>6. CATÁLOGO DE PRÊMIOS</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        6.1. As fotos dos prêmios divulgados no catálogo têm
                        caráter meramente ilustrativo. Caso algum item tenha
                        saído de linha ou não haja disponibilidade no mercado no
                        momento da compra, a Avon reserva-se ao direito de
                        substituí-lo, a seu exclusivo critério, por prêmios
                        equivalentes em potência, capacidade e qualidade, da
                        mesma marca ou similar ou, na impossibilidade de
                        substituição, à eliminá-lo em definitivo do catálogo. Os
                        elementos de produção das fotos não acompanham os
                        prêmios.
                      </p>

                      <p className='txt-body-sm mb-2'>
                        6.2. A Avon poderá, a qualquer momento, limitar os
                        prêmios, a quantidade e a oferta a cada Participante.
                        Para acesso a mais detalhes, tais como descritivo dos
                        prêmios e Parceiros de Resgate, o Participante poderá
                        acessar o Site do Meu Mundo Avon.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>7. VALIDADE DO PROGRAMA</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        7.1. A Avon reserva-se o direito de encerrar o programa
                        a qualquer tempo, com a respectiva comunicação da data
                        de encerramento às Revendedores participantes com
                        antecedência mínima de 30 (trinta) dias.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        7.2. Após o encerramento, todos os Pontos adquiridos e
                        não utilizados no Programa Meu Mundo Avon perderão a
                        validade.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        6.1. As fotos dos prêmios divulgados no catálogo têm
                        caráter meramente ilustrativo. Caso algum item tenha
                        saído de linha ou não haja disponibilidade no mercado no
                        momento da compra, a Avon reserva-se ao direito de
                        substituí-lo, a seu exclusivo critério, por prêmios
                        equivalentes em potência, capacidade e qualidade, da
                        mesma marca ou similar ou, na impossibilidade de
                        substituição, à eliminá-lo em definitivo do catálogo. Os
                        elementos de produção das fotos não acompanham os
                        prêmios.
                      </p>
                      <p className='txt-body-sm txt-uppercase mb-1'>
                        <strong>8. CONSIDERAÇÕES GERAIS</strong>
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.1. Para ter direito aos prêmios previstos no Programa
                        Meu Mundo Avon, a Revendedora deverá atender à todas as
                        condições previstas neste regulamento e nos respectivos
                        regulamentos que originaram o acúmulo de Pontos, sendo
                        tais documentos considerados, para efeitos deste
                        programa, como complementares e indissociáveis. Sem
                        prejuízo, para manter-se elegível e fazer jus aos
                        prêmios, deverá cumprir integralmente as regras
                        previstas nos documentos que estabeleçam as regras de
                        atuação como Revendedora Avon.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.2. Este Regulamento poderá ser alterado, a qualquer
                        tempo e a exclusivo critério da Avon, mediante prévia
                        comunicação às Revendedoras participantes.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.3. O presente regulamento revoga todos os regulamentos
                        anteriores sobre o mesmo programa de incentivo,
                        permanecendo válido por período indeterminado até que
                        modificado ou substituído, a critério da Avon, por um
                        novo regulamento.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.4. As Revendedoras participantes concordam com a
                        utilização de seu nome, voz e imagem para a divulgação
                        deste Programa, por prazo indeterminado, sem qualquer
                        ônus para a Avon.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.5. O prêmio a ser distribuído destina-se à Revendedora
                        que efetuar o Resgate, e será entregue em nome desta,
                        sendo vedada sua transferência.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.6. Em caso de falecimento da Revendedora, a Avon
                        poderá, mediante solicitação prévia e desde os pontos
                        não tenham expirado, conceder ao sucessor legítimo, a
                        possibilidade de resgatar o eventual prêmio a que teria
                        direito a Revendedora falecida.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.7. Os Pontos em nome da Revendedora serão
                        automaticamente cancelados na ocorrência de qualquer das
                        seguintes hipóteses: i. Solicitação, pela Revendedora,
                        de exclusão do Programa; ii. A Revendedora deixar de
                        cumprir qualquer de suas obrigações advindas deste
                        regulamento e/ou dos regulamentos dos Programas
                        Participantes, incluindo o contrato de prestação de
                        serviços de Executiva de Vendas e seus documentos
                        integrantes; iii. Se Avon constatar não ser verdadeira
                        qualquer informação que a Revendedora lhe tenha
                        fornecido, especialmente no que se refere a eventual
                        fraude; iv. Caso a Revendedora entre em Cobrança por não
                        pagamento do seu boleto de qualquer Campanha.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.8. A Avon poderá realizar ajustes na Pontuação da
                        Revendedora, a seu exclusivo critério, mediante
                        solicitação dos parceiros ou, em caráter excepcional,
                        mediante solicitação da Revendedora. Tal solicitação,
                        nesses casos, estará sujeita à avaliação e apuração por
                        parte da Avon. Os motivos que poderão ensejar ajustes na
                        Pontuação incluem, mas não se limitam, a erro sistêmico
                        e/ou falha humana.
                      </p>
                      <p className='txt-body-sm mb-2'>
                        8.9. Na hipótese de fundada suspeita ou efetiva
                        constatação de qualquer irregularidade ou distorção que
                        macule ou seja capaz de macular, a critério exclusivo da
                        Avon, o resultado em qualquer um dos critérios de
                        pontuação (Pedidos, Vendas, Devolução, Remessa)
                        utilizados neste Programa, a Avon se reserva ao direito
                        de desclassificar a Revededora a qualquer tempo, sem
                        prejuízo da adoção das medidas legais cabíveis para o
                        ressarcimento de eventuais prejuízos suportados pela
                        Avon.
                      </p>
                      <p className='txt-body-sm mb-2 '>
                        8.10. No caso de falta do prêmio por indisponibilidade
                        de estoque do catálogo impresso, a Avon reserva-se o
                        direito de retirá-lo do site de resgate, a qualquer
                        tempo.
                      </p>
                      <p className='txt-body-sm mb-2 '>
                        8.11. A Avon não se responsabiliza por riscos, acidentes
                        e danos ocorridos durante a utilização dos produtos
                        resgatados pela Revendedora, por meio do Programa,
                        devendo a Revendedora observar e cumprir todas as
                        especificações técnicas feitas pelo fabricante.
                      </p>

                      <p className='txt-body-sm mb-2 '>
                        8.12. Os casos não contemplados neste Regulamento serão
                        analisados individualmente e poderão ser acrescentados a
                        este documento a qualquer tempo.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default RegulationAvonComponent



// WEBPACK FOOTER //
// ./src/features/Regulation/RegulationAvonComponent.js